module.exports = __webpack_public_path__ + "assets/4b15644d1e47e19b65d5b9b2589222fe.svg";